/*
 * Ryan O'Dowd
 * 2025-05-19
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React from 'react';
import {
  ScrollView,
} from 'react-native';

const FullScreenScrollView = (props: FullScreenScrollViewProps & React.ComponentProps<typeof ScrollView>) => {
  if (props.noScroll) {
    return props.children;
  }

  return (
    <ScrollView
      {...props}
      contentContainerStyle={props.contentContainerStyle}
      nestedScrollEnabled={true}
    >
      {props.children}
    </ScrollView>
  );
};

class FullScreenScrollViewProps {
  noScroll?: boolean;
};

export default FullScreenScrollView;
